import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DescargaPolizaComponent } from './descarga-poliza.component';

const routes: Routes = [
  { path: '', component: DescargaPolizaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DescargaPolizaRoutingModule {}
